import React, { useLayoutEffect, useState } from "react";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { handleKeyOfInputForSearch } from "../../HandleSlice/HandleSlice";
// import { DatePicker } from "react-advance-jalaali-datepicker";
import "./Inputs.css";
import DatePickerCustomize from "../DatePickerCustomize/DatePickerCustomize";
import SelectSearch from "../SelectSearch/SelectSearch";
import SelectRoute from "../SelectRoute/SelectRoute";

const Inputs = (props) => {
    const dispatch = useDispatch();
    const [selectValue, setSelectValue] = useState("");

    const handleSearchExistButton = (e) => {
        setSelectValue(e.target.value);
        if (e.target.value !== "") {
        } else {
            const keyValue = e.target.getAttribute("key_value");
            let object = props.inputData;
            object[keyValue] = e.target.value;
            props.setInputData(object);
            props.searchClickHandler();
        }

        const keyValue = e.target.getAttribute("key_value");
        let object = props.inputData;
        object[keyValue] = e.target.value;
        props.setInputData(object);
    };

    const dateChangeHandler = (stringDate) => {
        // const keyValue = props.item.key;
        // let object = props.inputData;
        // object[keyValue] = stringDate;
        // props.setInputData(object);
        // props.searchClickHandler();
    };

    useLayoutEffect(() => {
        props.setInputData(props.inputData);
        // if(props.item.)
        let selectSearchOptions = [];
        let obj = props.selectSearchData;
        if (props.item.controlType === "select_dynamic") {
            if (props.item.options !== undefined) {
                for (let option of props.item.options) {
                    selectSearchOptions.push({
                        label: option.label,
                        value: option.value,
                    });
                }
            }
            obj[props.item.key + "-" + "0"] = selectSearchOptions;
            obj["label"] = null;
            props.setSelectSearchData(obj);
        }
        if (props.item.controlType === "select_search" && props.item.relation) {
            for (let option of props.item.options) {
                selectSearchOptions.push({ label: option.label, value: option.value });
            }
            obj[props.item.key] = selectSearchOptions;
            props.setSelectSearchData(obj);
        } else if (props.item.controlType === "select_search") {
            if (!Array.isArray(props.item.options)) {
                selectSearchOptions.push({ label: "", value: "" });
            } else {
                for (let option of props.item.options) {
                    selectSearchOptions.push({
                        label: option.label,
                        value: option.value,
                    });
                }
            }
            obj[props.item.key] = selectSearchOptions;
            props.setSelectSearchData(obj);
        }
    }, []);

    function DatePickerInput(props) {
        return <input className="outline-none" {...props} />;
    }

    useEffect(() => {
        dispatch(handleKeyOfInputForSearch(props.item));
    }, [dispatch, props.item]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        setSelectValue(urlParams.get(`${props.item.key}`))
        if (document.querySelector(`[key_value=${props.item.key}]`) !== null) {
            document.querySelector(`[key_value=${props.item.key}]`).value =
                urlParams.get(`${props.item.key}`);
        }
    }, [props.item]);

    switch (props.item.controlType) {
        case "text":
            return (
                <div className={`w-full flex flex-col`} key={props.index}>
                    <label
                        htmlFor={"textField"}
                        className="text-search_input_label text-[14px] w-full text-black dark:text-white mb-[10px]"
                    >
                        {props.item.label}:
                    </label>
                    <input
                        type={props.item.type || "text"}
                        className={`h-[38px] dark:bg-[#ffffffdd] border border-edit_input_border ${
                            props.item.disabled
                                ? "text-edit_input_text"
                                : "edit_input_text_disabled"
                        } dark:text-[#555555] rounded-[4px] px-3 w-full ${
                            props.matchpointId
                        }`}
                        key_value={props.item.key}
                        onKeyUp={props.handleKeyPress}
                        onChange={handleSearchExistButton}
                        pageType={"search"}
                        // onBlur={inputHandler}
                    />
                </div>
            );
        case "select":
            return (
                <div className={`w-full flex flex-col`}>
                    <label className="text-search_input_label text-[14px] text-black dark:text-white">
                        {props.item.label}:
                    </label>
                    <select
                        className="serachInput border bg-white dark:bg-[#ffffffdd] border-search_input_border rounded-[5px] w-full h-[38px] mt-[10px] text-search_input_label text-[14px] outline-none px-2 transition-shadow"
                        key_value={props.item.key}
                        // onChange={inputHandler}
                        // onKeyUp={props.handleKeyPress}
                        onChange={handleSearchExistButton}
                        // onBlur={inputHandler}
                        // value={selectValue}
                    >
                        <option value={""}>انتخاب کنید</option>
                        {props.item.options &&
                            props.item.options.map((item) => (
                                <option
                                    key={item.key}
                                    className="text-search_input_label text-[14px]"
                                    selected={item.value === selectValue}
                                    value={item.value}
                                >
                                    {item.label}
                                </option>
                            ))}
                    </select>
                </div>
            );
        case "select_route":
            return (
                <div className={`w-full flex flex-col`}>
                    <label className="text-search_input_label text-[14px] text-black dark:text-white mb-[10px]">
                        {props.item.label}:
                    </label>
                    <SelectRoute
                        itemRoute={props.item.route}
                        item={props.item}
                        pageType={props.pageType}
                        inputData={props.inputData}
                        setInputData={props.setInputData}
                        index={props.index}
                        machOptionsClass={"matche-options" + props.index}
                        children={props.children}
                    />
                </div>
            );
        case "select_search":
            return (
                <div className={`w-full flex flex-col bg-white dark:bg-[#ffffffdd]`}>
                    <label className="text-search_input_label text-[14px] text-black dark:text-white mb-[10px]">
                        {props.item.label}:
                    </label>
                    <SelectSearch
                        item={props.item}
                        inputData={props.inputData}
                        setInputData={props.setInputData}
                        selectSearchData={props.selectSearchData}
                        setSelectSearchData={props.setSelectSearchData}
                        matchpointId={props.matchpointId}
                        children={props.children}
                    />
                </div>
            );
        // case "number":
        //   return (
        //     <>
        //       <div className={`w-full flex flex-col`}>
        //         <label
        //           for={"textField"}
        //           className="text-search_input_label text-[14px] text-black dark:text-white"
        //         >
        //           {props.item.label}:
        //         </label>
        //         <input
        //           type="number"
        //           id="textField"
        //           className="serachInput border bg-white dark:bg-[#ffffffdd] border-search_input_border focus:border-search_input_border-focus rounded-[5px] w-full h-[38px] mt-[10px] outline-none px-2 focus:shadow-[0px_5px_10px_0px_#00000024] transition-shadow duration-1000"
        //           key_value={props.item.key}
        //           onChange={handleSearchExistButton}
        //           // onBlur={inputHandler}
        //           // onKeyUp={props.handleKeyPress}
        //         />
        //       </div>
        //     </>
        //   );
        case "date":
            return (
                <div className={`w-full flex flex-col `}>
                    <label className="text-search_input_label text-[14px] text-black dark:text-white">
                        {props.item.label}
                    </label>
                    <div>
                        <div
                            dir={"rtl"}
                            className={`serachInput border border-search_input_border focus:border-search_input_border-focus flex items-center rounded-[5px] w-[100%] h-[38px] mt-[10px] outline-none focus:shadow-[0px_5px_20px_10px_#00000024] transition-all duration-1000`}
                        >
                            <DatePickerCustomize
                                keyValue={props.item.key}
                                pageType={props.pageType}
                                inputData={props.inputData}
                                setInputData={props.setInputData}
                                searchClickHandler={props.searchClickHandler}
                                item={props.item}
                            />
                        </div>
                    </div>
                </div>
            );
        default:
            return "";
    }
};

export default React.memo(Inputs);
